export const MAIN_API = process.env.REACT_APP_MAIN_API;

export const AUTH_API = process.env.REACT_APP_AUTH_API;

export const AXIOS_OPTIONS = {
    headers: {
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_APIKEY,
        "authorization": localStorage.getItem("jwt")
    }
}

export const AUTH_AXIOS_OPTIONS = {
    headers: {
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_AUTH_APIKEY,
        "authorization": localStorage.getItem("jwt")
    }
}

export const APP_NAME = "ISSET | Recibos de pago";

export const MONTHS = [
    {
        name: "Enero",
        id: 1
    },
    {
        name: "Febrero",
        id: 2
    },
    {
        name: "Marzo",
        id: 3
    },
    {
        name: "Abril",
        id: 4
    },
    {
        name: "Mayo",
        id: 5
    },
    {
        name: "Junio",
        id: 6
    },
    {
        name: "Julio",
        id: 7
    },
    {
        name: "Agosto",
        id: 8
    },
    {
        name: "Septiembre",
        id: 9
    },
    {
        name: "Octubre",
        id: 10
    },
    {
        name: "Noviembre",
        id: 11
    },
    {
        name: "Diciembre",
        id: 12
    }
]